import styled from "@emotion/styled"

export const RequiredIndicator = styled((props) => (
    <span {...props}>*</span>
))`
    color: var(--chakra-colors-service-red);
    margin-left: 2px;
`